import { createFileRoute } from '@tanstack/react-router';
import Invoice from 'src/pages/Organization/Invoice';

export const Route = createFileRoute('/$organizationSlug/invoice/')({
  component: Invoice,
});
